import { render, staticRenderFns } from "./ConfigureTasks.vue?vue&type=template&id=de8891bc&scoped=true"
import script from "./ConfigureTasks.vue?vue&type=script&lang=ts"
export * from "./ConfigureTasks.vue?vue&type=script&lang=ts"
import style0 from "./ConfigureTasks.vue?vue&type=style&index=0&id=de8891bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8891bc",
  null
  
)

export default component.exports